import { render, staticRenderFns } from "./ListUnnaprovedUsers.vue?vue&type=template&id=f11af26a&"
import script from "./ListUnnaprovedUsers.vue?vue&type=script&lang=js&"
export * from "./ListUnnaprovedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports